import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchPrograms = () => api.get("/programs").then((r) => r.data.programs);
export const fetchProgram = (slug) => api.get(`/programs/${slug}`).then((r) => r.data);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data.testimonials);
export const fetchBlog = () => api.get("/blog").then((r) => r.data.posts);
export const fetchBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const fetchSchedule = () => api.get("/schedule").then((r) => r.data.schedule);
export const fetchFaqs = () => api.get("/faqs").then((r) => r.data.faqs);

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const submitBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const submitEnrollment = (payload) => api.post("/enrollments", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
